export class AuditLog {
	public username: string;
	public dateAccessed: string;
	public documentName: string;
	public documentId: string;
	public case: string;
}
